import { render, staticRenderFns } from "./MasonryColumnsCell.vue?vue&type=template&id=40db6ac8&scoped=true"
import script from "./MasonryColumnsCell.vue?vue&type=script&lang=js"
export * from "./MasonryColumnsCell.vue?vue&type=script&lang=js"
import style0 from "./MasonryColumnsCell.vue?vue&type=style&index=0&id=40db6ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db6ac8",
  null
  
)

export default component.exports